module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/ts-loader/index.js!./reset-password.ts"));
	}, "reset-password");
}